import { type Change, TextRange } from '@gitbook/slate';

import { SELECTION_HIGHLIGHTING_MARK } from './plugin';

/**
 * Clear any selection highlighting in the editor.
 */
export function clearSelectionHighlighting(change: Change) {
    change.value.decorations.forEach((range) => {
        if (range.marks?.some((mark) => mark.type === SELECTION_HIGHLIGHTING_MARK)) {
            change.removeValueDecoration(range);
        }
    });
}

/**
 * Add selection highlighting mark in the editor.
 * Defaults to use the current `change` selection.
 */
export function highlightSelection(change: Change, selection = change.value.selection) {
    if (TextRange.isTextRange(selection)) {
        change.setValueDecoration(
            TextRange.create({
                anchorKey: selection.anchorKey,
                anchorOffset: selection.anchorOffset,
                focusKey: selection.focusKey,
                focusOffset: selection.focusOffset,
                isBackward: selection.isBackward,
                marks: [
                    {
                        type: SELECTION_HIGHLIGHTING_MARK,
                        data: {},
                    },
                ],
                isAtomic: true,
            })
        );
    }
}
